import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  PartialReleasePayload,
  BulkPartialReleaseItem,
  partialReleaseBundle,
  partialReleaseBundlesBulk,
  fullRolloutBundle,
  fullRolloutBundlesBulk,
} from "../services/pricing-lifecycle";

export function usePartialReleaseBundle() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      baselineId,
      payload,
    }: {
      baselineId: string;
      payload: PartialReleasePayload;
    }) => partialReleaseBundle(baselineId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}

export function usePartialReleaseBundlesBulk() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      releases,
      released_at,
    }: {
      releases: BulkPartialReleaseItem[];
      released_at: string;
    }) => partialReleaseBundlesBulk(releases, released_at),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}

export function useFullRolloutBundle() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (bundleId: string) => fullRolloutBundle(bundleId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}

export function useFullRolloutBundlesBulk() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (bundleIds: string[]) => fullRolloutBundlesBulk(bundleIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}
